import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, Loader, NoItemsYet } from 'components';
import { FindLoad, Images, sortListByKey, useModal } from 'utils';
import { systemItemStyles } from './styles';
import { systemActions } from 'store';
import { CreateEditDepartment } from './modals/createEditDepartment';
import { departNotYet } from './constants';

const ACTION_TYPE = 'GET_DEPARTMENTS';
export const Departments = ({ }) => {
    const globalDepartments = useSelector((state) => state.system.departments);
    const classes = systemItemStyles();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { open } = useModal();
    const departmentsList = sortListByKey(globalDepartments, 'name');

    useEffect(() => {
        dispatch(systemActions.getDepartments());
    }, []);


    if (loader?.length) {
        return <Loader />;
    }

    return (
        <Fragment>
            <div className="header-action-btn">
                <AddCircleBlue text={'Add Department'} handleClick={() => open(<CreateEditDepartment />)} />
            </div>
            {departmentsList?.length ? (
                <div className={classes.credentialTable}>
                    {departmentsList?.map((departmentItem, index) => {
                        return (
                            <div className={classes.item} key={index}>
                                <p>
                                    <span>{departmentItem?.name}</span>
                                </p>
                                <div className={classes.icons}>
                                    <img src={Images.edit} onClick={() => open(<CreateEditDepartment info={departmentItem} />)} alt="edit" />
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <NoItemsYet height={'300px'} text={departNotYet.title} subTitle={departNotYet.subTitle} image={departNotYet.image} />
            )}
        </Fragment>
    );
};
